import { hiprint } from "vue-plugin-hiprint";

const FORM_TABLE_TID = "modelEngineModule.formTable";
const MM_TO_PT = 72 / 25.4;
const LABEL_MAX_HEIGHT_MM = 100;
const LABEL_MAX_WIDTH_MM = 150;
const HEADER_RATIO = 0.15;

export function mmToPt(mm) {
  const n = parseFloat(mm);
  return n ? n * MM_TO_PT : 0;
}

export function isLabelPrintPaper(panel) {
  if (!panel) {
    return false;
  }
  const width = parseFloat(panel.width) || 0;
  const height = parseFloat(panel.height) || 0;
  return width > 0 && height > 0 && width <= LABEL_MAX_WIDTH_MM && height <= LABEL_MAX_HEIGHT_MM;
}

export function isFormTablePrintElement(el) {
  if (!el) {
    return false;
  }
  const tid = (el.tid || (el.printElementType && el.printElementType.tid) || "").toString();
  if (tid === FORM_TABLE_TID || tid.indexOf("formTable") >= 0) {
    return true;
  }
  const opt = el.options || {};
  return !!opt.formTableJson;
}

function elementBox(el) {
  const opt = (el && el.options) || {};
  return {
    top: parseFloat(opt.top) || 0,
    left: parseFloat(opt.left) || 0,
    width: parseFloat(opt.width) || 0,
    height: parseFloat(opt.height) || 0,
  };
}

function boxesOverlap(a, b) {
  return (
    a.left < b.left + b.width &&
    a.left + a.width > b.left &&
    a.top < b.top + b.height &&
    a.top + a.height > b.top
  );
}

function ensureOptions(el) {
  if (!el.options || typeof el.options !== "object") {
    el.options = {};
  }
  return el.options;
}

export function normalizePrintPanelPaging(panel) {
  if (!panel || typeof panel !== "object") {
    return panel;
  }
  const els = Array.isArray(panel.printElements) ? panel.printElements : [];
  const tables = els.filter(isFormTablePrintElement).map(elementBox);
  els.forEach((el) => {
    if (!el) {
      return;
    }
    const opt = ensureOptions(el);
    if (isFormTablePrintElement(el)) {
      opt.fixed = true;
      return;
    }
    if (tables.some((box) => boxesOverlap(elementBox(el), box))) {
      opt.fixed = true;
    }
  });
  if (isLabelPrintPaper(panel)) {
    const heightPt = mmToPt(panel.height);
    panel.panelPageRule = "none";
    if ((parseFloat(panel.paperHeader) || 0) > heightPt * HEADER_RATIO) {
      panel.paperHeader = 0;
    }
    panel.paperFooter = heightPt;
    panel.firstPaperFooter = undefined;
    panel.oddPaperFooter = undefined;
    panel.evenPaperFooter = undefined;
    panel.lastPaperFooter = undefined;
    els.forEach((el) => {
      if (el) {
        ensureOptions(el).fixed = true;
      }
    });
  }
  // 设计器缩放只用于编辑预览，打印时按 1:1，避免字段错位
  if (panel.scale != null && Number(panel.scale) !== 1) {
    panel.scale = 1;
  }
  return panel;
}

export function normalizePrintTemplateJson(raw) {
  if (raw == null || raw === "") {
    return raw;
  }
  let json = raw;
  if (typeof raw === "string") {
    json = JSON.parse(raw);
  } else {
    json = JSON.parse(JSON.stringify(raw));
  }
  const panels = json && json.panels;
  if (Array.isArray(panels)) {
    panels.forEach(normalizePrintPanelPaging);
  }
  return json;
}

export function createNormalizedHiprintTemplate(source) {
  const hp = hiprint || (typeof window !== "undefined" && window.hiprint);
  if (!hp || !hp.PrintTemplate) {
    return source;
  }
  try {
    const raw =
      source && typeof source.getJson === "function" ? source.getJson() : source;
    const json = normalizePrintTemplateJson(raw);
    if (!json || typeof json !== "object") {
      return source;
    }
    const tpl = new hp.PrintTemplate({ template: json });
    if (!tpl.printPanels || !tpl.printPanels.length) {
      return source;
    }
    return tpl;
  } catch (e) {
    return source;
  }
}
